export const api = {
    fetch: async (endpoint, options = {}, token) => {
        const headers = { 'Content-Type': 'application/json' };
        if (token) headers['Authorization'] = `Bearer ${token}`;
        const isGetRequest = !options.method || options.method === 'GET';
        const finalEndpoint = isGetRequest ? `${endpoint}${endpoint.includes('?') ? '&' : '?'}t=${Date.now()}` : endpoint;

        try {
            const response = await fetch(`/api${finalEndpoint}`, { ...options, headers, cache: 'no-store' });
            
            if (!response.ok) {
                if ((response.status === 401 || response.status === 403) && !options.isLoginAttempt) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    window.location.reload();
                    return;
                }
                const errText = await response.text();
                // FIX: Blokkeer HTML dumps die React laten crashen
                const safeMessage = errText.startsWith('<') ? 'Server is tijdelijk onbereikbaar.' : errText;
                throw new Error(safeMessage);
            }
            
            const text = await response.text();
            if (!text) return null;
            try { 
                return JSON.parse(text); 
            } catch(e) { 
                // FIX: Als we geen JSON krijgen, check of het geen foute HTML is
                if (text.startsWith('<')) throw new Error('Ongeldige response van de server.');
                return text; 
            }
        } catch (error) {
            console.error(`API Error [${endpoint}]:`, error.message);
            throw error;
        }
    }
};